import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator, levelEnumValidator } from '../../validators';

export const AssessSummarySchema = z.object({
  language: languageEnumValidator.optional().default(LanguageEnum.RU),
  level: levelEnumValidator,
  originalText: z.string().min(1, 'Original text cannot be empty.'),
  userSummary: z.string().min(1, 'User summary cannot be empty.'),
});

export type IAssessSummaryDto = z.infer<typeof AssessSummarySchema>;
